import { beatAriadne } from "../../../ariadne/report";
import type { Achievement } from "../achievement.types";

/** Finished a daily ahead of her (match verdict, Ariadne v2 spec §5). Was uRobot; renamed with v2 (A1). */
export const aStepAheadAchievement: Achievement = {
  id: "aStepAhead",
  name: "A Step Ahead",
  description: "Finished a daily ahead of Ariadne.",
  icon: "shoe-print",
  isProgressive: true,
  check: (gameReport, gameStatus) =>
    gameStatus === "won" &&
    !!gameReport?.isDailyChallenge &&
    !!gameReport.ariadne &&
    beatAriadne(gameReport.ariadne.verdict),
};
